import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [title, setTitle] = useState(null)
  const [content, setContent] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const showModal = (title,modalContent) => {
    setTitle(title);
    setContent(modalContent);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
    setContent(null);
  };

  return (
    <ModalContext.Provider value={{ isOpen, title, content, showModal, hideModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);